// src/components/landing/LandingHeader.jsx
import React, { useState, useEffect } from 'react';

const LandingHeader = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeMobileDropdown, setActiveMobileDropdown] = useState(null);

  const toggleMobileDropdown = (dropdown) => {
    if (activeMobileDropdown === dropdown) {
      setActiveMobileDropdown(null);
    } else {
      setActiveMobileDropdown(dropdown);
    }
  };

  return (
    <>
      {/* Top Navigation - Sticky */}
      <div className="top-nav-custom text-white py-2 " style={{ backgroundColor: '#250242' }}>
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <a href="https://asfirj.org/" className="flex items-center">
                <img 
                  src="https://asfirj.org/assets/images/logoIcon/logo.png" 
                  alt="ASFI Research Journal" 
                  className="h-8 filter grayscale brightness-0 invert"
                />
              </a>
            </div>
            
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden text-white"
            >
              <i className={`fas fa-${mobileMenuOpen ? 'times' : 'bars'} text-xl`}></i>
            </button>
            
            <div className="hidden md:flex space-x-6">
              <a href="https://asfirj.org/issues" className="hover:text-asfi-gold transition-colors">Explore ASFIRJ</a>
              <a href="https://asfirj.org/authors.html#ob" className="hover:text-asfi-gold transition-colors">Get Published</a>
              <a href="https://asfischolar.org/" target="_blank" rel="noopener noreferrer" className="hover:text-asfi-gold transition-colors">ASFIScholar</a>
              <a href="https://africansciencefrontiers.com/about.php" target="_blank" rel="noopener noreferrer" className="hover:text-asfi-gold transition-colors">About ASFI</a>
              <a href="https://asfirj.org/events.html" className="hover:text-asfi-gold transition-colors">Events</a>
              <a href="/portal/login" className="hover:text-asfi-gold transition-colors">Login</a>
            </div>
          </div>
          
          {/* Mobile Menu
          {mobileMenuOpen && (
            <div className="md:hidden mt-4">
              <div className="flex flex-col space-y-3">
                <a href="https://asfirj.org/issues" className="hover:text-asfi-gold transition-colors py-1">Explore ASFIRJ</a>
                <a href="https://asfirj.org/authors.html#ob" className="hover:text-asfi-gold transition-colors py-1">Get Published</a>
                <a href="https://asfischolar.org/" target="_blank" rel="noopener noreferrer" className="hover:text-asfi-gold transition-colors py-1">ASFIScholar</a>
                <a href="https://africansciencefrontiers.com/about.php" target="_blank" rel="noopener noreferrer" className="hover:text-asfi-gold transition-colors py-1">About ASFI</a>
                <a href="https://asfirj.org/events.html" className="hover:text-asfi-gold transition-colors py-1">Events</a>
                <a href="/portal/login" className="hover:text-asfi-gold transition-colors py-1">Login</a>
              </div>
            </div>
          )} */}
        </div>
      </div>

      {/* Journal Banner */}
      <div 
        className="gradient-bg text-white py-8" 
        style={{ 
          backgroundImage: "url('https://imgs.search.brave.com/cUyDB5RbxDT6km2QpechP4jC8DWbOKLTT2KB1I0yDoU/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5pc3RvY2twaG90/by5jb20vaWQvMTUz/NTAwMTcxL3Bob3Rv/L2pvdXJuYWwtd2l0/aC1wZW4tb24tdG9w/LW9mLWEtbGFwdG9w/LmpwZz9zPTYxMng2/MTImdz0wJms9MjAm/Yz1BdmZSSlhsaF9f/b0J6ZGhqSDNPZkR6/STRWOUpkYUhaU1BU/Z2w3YXRzU3N3PQ')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="container mx-2 lg:mx-10 p-4 text-center w-[max-content] bg-[--asfi-blue]" style={{ backgroundColor: '#8703a1ff' }} >
          <h1 className="text-2xl lg:text-3xl md:text-4xl font-medium">ASFI Research Journal</h1>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            {/* Mobile menu button */}
            <div className="lg:hidden">
              <button 
                type="button" 
                className="text-asfi-dark hover:text-asfi-blue focus:outline-none focus:text-asfi-blue"
                id="mobile-menu-button"
                onClick={() => {setMobileMenuOpen(!mobileMenuOpen)}}
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex lg:space-x-8">
              <a href="https://asfirj.org/" className="text-asfi-dark hover:text-asfi-blue font-medium transition-colors">Home</a>
              
              <div className="relative group">
                <a href="https://asfirj.org/aboutus.html" className="text-asfi-dark hover:text-asfi-blue font-medium transition-colors flex items-center">
                  About <i className="fas fa-chevron-down ml-1 text-xs"></i>
                </a>
                <div className="absolute top-full left-0 bg-white min-w-[200px] shadow-lg rounded-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
                  <a href="https://asfirj.org/aboutus.html#ASFI" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-asfi-blue border-b border-gray-100">African Science Frontiers Initiatives</a>
                  <a href="https://asfirj.org/aboutus.html#aims" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-asfi-blue border-b border-gray-100">ASFIRJ's AIMS & SCOPE</a>
                  <a href="https://asfirj.org/aboutus.html#values" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-asfi-blue border-b border-gray-100">ASFIRJ Values</a>
                  <a href="https://asfirj.org/aboutus.html#prompt" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-asfi-blue border-b border-gray-100">Prompt Decisions and Rapid Publication</a>
                  <a href="https://asfirj.org/aboutus.html#why-section" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-asfi-blue border-b border-gray-100">Why Publish in ASFIRJ?</a>
                  <a href="https://asfirj.org/aboutus.html#open-access" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-asfi-blue border-b border-gray-100">Open Access and Author Licensing</a>
                  <a href="https://asfirj.org/aboutus.html#fees" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-asfi-blue">Article Publication Fee</a>
                </div>
              </div>
              
              <div className="relative group">
                <a href="https://asfirj.org/issues" className="text-asfi-dark hover:text-asfi-blue font-medium transition-colors flex items-center">
                  Browse Issues <i className="fas fa-chevron-down ml-1 text-xs"></i>
                </a>
                <div className="absolute top-full left-0 bg-white min-w-[200px] shadow-lg rounded-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
                  <a href="https://asfirj.org/issues" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-asfi-blue border-b border-gray-100">Issues</a>
                  <a href="https://asfirj.org/supplements" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-asfi-blue">Supplements</a>
                </div>
              </div>
              
              <a href="https://asfirj.org/editors.html" className="text-asfi-dark hover:text-asfi-blue font-medium transition-colors">Meet The Editors</a>
              
              <div className="relative group">
                <a href="#" className="text-asfi-dark hover:text-asfi-blue font-medium transition-colors flex items-center">
                  Authors / Reviewers <i className="fas fa-chevron-down ml-1 text-xs"></i>
                </a>
                <div className="absolute top-full left-0 bg-white min-w-[200px] shadow-lg rounded-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
                  <a href="https://asfirj.org/authors.html" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-asfi-blue border-b border-gray-100">For Authors</a>
                  <a href="https://asfirj.org/reviewers.html" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-asfi-blue">For Reviewers</a>
                </div>
              </div>
              <a href="https://asfirj.org/careercorner" className="text-asfi-dark hover:text-asfi-blue font-medium transition-colors">Career Corner</a>
              <a href="https://asfirj.org/special-issues" className="text-asfi-dark hover:text-asfi-blue font-medium transition-colors">Special Issues</a>
              <a href="https://asfirj.org/theses.php" className="text-asfi-dark hover:text-asfi-blue font-medium transition-colors">ASFIRJ Theses</a>
              <a href="https://asfirj.org/contact.php" className="text-asfi-dark hover:text-asfi-blue font-medium transition-colors">Contact</a>
            </div>
            
            {/* Submit Manuscript Button */}
            <a href="/portal" className="bg-asfi-blue text-white px-4 py-2 rounded-md font-medium hover:bg-purple-800 transition-colors whitespace-nowrap">
              Submit Manuscript
            </a>
          </div>

          {/* Mobile Navigation Menu */}
            {mobileMenuOpen && (
          <div className="" id="mobile-menu">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t">
              <a href="https://asfirj.org/" className="block px-3 py-2 text-asfi-dark hover:text-asfi-blue font-medium">Home</a>
              
              {/* Mobile About Dropdown */}
              <div className="relative">
                <button 
                  onClick={() => toggleMobileDropdown('about')}
                  className="w-full text-left px-3 py-2 text-asfi-dark hover:text-asfi-blue font-medium flex justify-between items-center"
                >
                  About <i className={`fas fa-chevron-${activeMobileDropdown === 'about' ? 'up' : 'down'} text-xs`}></i>
                </button>
                {activeMobileDropdown === 'about' && (
                  <div className="pl-4">
                    <a href="https://asfirj.org/aboutus.html#ASFI" className="block px-3 py-2 text-sm text-asfi-dark hover:text-asfi-blue">African Science Frontiers Initiatives</a>
                    <a href="https://asfirj.org/aboutus.html#aims" className="block px-3 py-2 text-sm text-asfi-dark hover:text-asfi-blue">ASFIRJ's AIMS & SCOPE</a>
                    <a href="https://asfirj.org/aboutus.html#values" className="block px-3 py-2 text-sm text-asfi-dark hover:text-asfi-blue">ASFIRJ Values</a>
                    <a href="https://asfirj.org/aboutus.html#prompt" className="block px-3 py-2 text-sm text-asfi-dark hover:text-asfi-blue">Prompt Decisions and Rapid Publication</a>
                    <a href="https://asfirj.org/aboutus.html#why-section" className="block px-3 py-2 text-sm text-asfi-dark hover:text-asfi-blue">Why Publish in ASFIRJ?</a>
                    <a href="https://asfirj.org/aboutus.html#open-access" className="block px-3 py-2 text-sm text-asfi-dark hover:text-asfi-blue">Open Access and Author Licensing</a>
                    <a href="https://asfirj.org/aboutus.html#fees" className="block px-3 py-2 text-sm text-asfi-dark hover:text-asfi-blue">Article Publication Fee</a>
                  </div>
                )}
              </div>
              
              {/* Mobile Browse Issues Dropdown */}
              <div className="relative">
                <button 
                  onClick={() => toggleMobileDropdown('issues')}
                  className="w-full text-left px-3 py-2 text-asfi-dark hover:text-asfi-blue font-medium flex justify-between items-center"
                >
                  Browse Issues <i className={`fas fa-chevron-${activeMobileDropdown === 'issues' ? 'up' : 'down'} text-xs`}></i>
                </button>
                {activeMobileDropdown === 'issues' && (
                  <div className="pl-4">
                    <a href="https://asfirj.org/issues" className="block px-3 py-2 text-sm text-asfi-dark hover:text-asfi-blue">Issues</a>
                    <a href="https://asfirj.org/supplements" className="block px-3 py-2 text-sm text-asfi-dark hover:text-asfi-blue">Supplements</a>
                  </div>
                )}
              </div>
              
              <a href="https://asfirj.org/editors.html" className="block px-3 py-2 text-asfi-dark hover:text-asfi-blue font-medium">Meet The Editors</a>
              
              {/* Mobile Authors/Reviewers Dropdown */}
              <div className="relative">
                <button 
                  onClick={() => toggleMobileDropdown('authors')}
                  className="w-full text-left px-3 py-2 text-asfi-dark hover:text-asfi-blue font-medium flex justify-between items-center"
                >
                  Authors / Reviewers <i className={`fas fa-chevron-${activeMobileDropdown === 'authors' ? 'up' : 'down'} text-xs`}></i>
                </button>
                {activeMobileDropdown === 'authors' && (
                  <div className="pl-4">
                    <a href="https://asfirj.org/authors.html" className="block px-3 py-2 text-sm text-asfi-dark hover:text-asfi-blue">For Authors</a>
                    <a href="https://asfirj.org/reviewers.html" className="block px-3 py-2 text-sm text-asfi-dark hover:text-asfi-blue">For Reviewers</a>
                  </div>
                )}
              </div>
              <a href="https://asfirj.org/careercorner" className="block px-3 py-2 text-asfi-dark hover:text-asfi-blue font-medium">Career Corner</a>
              <a href="https://asfirj.org/special-issues" className="block px-3 py-2 text-asfi-dark hover:text-asfi-blue font-medium">Special Issues</a>
              <a href="https://asfirj.org/theses.php" className="block px-3 py-2 text-asfi-dark hover:text-asfi-blue font-medium">ASFIRJ Theses</a>
              <a href="https://asfirj.org/contact.php" className="block px-3 py-2 text-asfi-dark hover:text-asfi-blue font-medium">Contact Us</a>
            </div>
          </div>
            )}
        </div>
      </nav>
    </>
  );
};

export default LandingHeader;